import i18next from "i18next";

import { FormatLanguageEnum } from "@/app/i18n/utils/enums/FormatLanguageEnum";
import { formatLanguageKey } from "@/app/i18n/utils/formatLanguageKey";
import { LocaleEnum } from "@/types/utils/locale";
import { checkExistValue } from "@/utils/common/validateHelper/validateUtils";

export const getDataByLocalized = <T extends unknown>(
  key?: Record<string, T>,
  { customLangKey = "", formatLang = FormatLanguageEnum.DEFAULT } = {},
): T | null => {
  const language = i18next.languages[0] ?? "en-us";
  if (!key) return null;
  const fallbackLangKey = key[formatLanguageKey(LocaleEnum.EN, formatLang)];
  const formatLangKey = formatLanguageKey(language, formatLang);
  const langKey = checkExistValue(customLangKey)
    ? `${customLangKey}${formatLangKey}`
    : formatLangKey;
  const value = key[langKey] || fallbackLangKey || null;
  return value;
};

export const useLocalizedTranslation = () => {
  return { getDataByLocalized };
};
